import React from 'react'

interface FollowUpCountdownBadgeProps {
  label: string
  variant: 'countdown' | 'window' | 'blocked' | 'starting'
}

const variantClassName: Record<FollowUpCountdownBadgeProps['variant'], string> = {
  countdown: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
  window: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  blocked: 'bg-neutral-500/15 text-neutral-300 border-neutral-500/30',
  starting: 'bg-green-500/15 text-green-300 border-green-500/30',
}

export const FollowUpCountdownBadge: React.FC<FollowUpCountdownBadgeProps> = ({ label, variant }) => {
  return (
    <div
      className={`max-w-[260px] truncate text-xs px-2.5 py-1.5 rounded-md border ${variantClassName[variant]}`}
      title={label}
    >
      {label}
    </div>
  )
}
